import { useEffect } from 'react';
import UnifiedSEO from '@/components/seo/UnifiedSEO';
import CriticalCSS from '@/components/seo/CriticalCSS';
import PerformanceOptimization from '@/components/seo/PerformanceOptimization';
import InternalLinkingOptimizer from '@/components/seo/InternalLinkingOptimizer';
import PerformanceOptimizer from '@/components/seo/PerformanceOptimizer';
import { TestimonialSchema } from '@/components/seo/TestimonialSchema';
import LocalBusinessSchema from '@/components/seo/LocalBusinessSchema';
import SoftwareAppSchema from '@/components/seo/SoftwareAppSchema';
import { testimonials as storyTestimonials } from '@/data/stories/testimonials';
import { OG_IMAGES } from '@/constants/seoImages';

// New homepage sections - Older Adult First Strategy
import HomeHeroOS from '@/components/home/HomeHeroOS';
import DailyPulseSection from '@/components/home/DailyPulseSection';
import SystemModulesSection from '@/components/home/SystemModulesSection';
import FamilyBridgeSection from '@/components/home/FamilyBridgeSection';
import SimpleStartSection from '@/components/home/SimpleStartSection';
import FooterFamilyCallout from '@/components/home/FooterFamilyCallout';

const Home = () => {
  useEffect(() => {
    // Mark key user interactions for performance monitoring
    if ('performance' in window && 'mark' in performance) {
      performance.mark('home-component-loaded');
    }
  }, []);

  const structuredTestimonials = storyTestimonials.slice(0, 3).map(t => ({
    quote: t.quote,
    author: t.name,
    rating: 5,
  }));

  return (
    <>
      <UnifiedSEO 
        title="SeniorThrive - Live at Home with Confidence"
        description="SeniorThrive helps older adults stay safe and independent at home with room-by-room safety insights, wellness tracking, and family coordination. Start free."
        keywords="senior safety, aging in place, home safety, family caregiving, senior care coordination, fall prevention, wellness tracking, independence at home, ThriveMax, ThriveVision"
        canonical="https://seniorthrive.com/"
        image={OG_IMAGES.home}
        breadcrumbs={[
          { name: "Home", url: "https://seniorthrive.com/" }
        ]}
      />

      {/* Advanced Schema for Local SEO & App */}
      <LocalBusinessSchema />
      <SoftwareAppSchema />
      <TestimonialSchema testimonials={structuredTestimonials} />
      
      <CriticalCSS />
      <PerformanceOptimization 
        preloadImages={[
          '/lovable-uploads/happy-senior-couple.jpg',
          '/lovable-uploads/family-thrive-circle-main.jpg'
        ]}
      />
      <PerformanceOptimizer 
        criticalResourceUrls={[
          '/lovable-uploads/078e2577-2ebf-456e-be33-dc5d16a6e60b.png',
          '/lovable-uploads/69b1dd60-a9f8-468e-85c3-6dc3ddb382f5.png'
        ]}
      />
      
      {/* Section 1: Hero - Full Width, Older Adult Focused */}
      <HomeHeroOS />
      
      {/* Section 2: Daily Pulse - 3-Card Grid */}
      <DailyPulseSection />
      
      {/* Section 3: System Modules - 2x2 Grid */}
      <SystemModulesSection />
      
      {/* Section 4: Family Bridge - Relationship Layer */}
      <FamilyBridgeSection />
      
      {/* Section 5: Simple Start - 3-Step CTA */}
      <SimpleStartSection />
      
      {/* Section 6: Footer Family Callout */}
      <FooterFamilyCallout />
      
      {/* Internal Linking at bottom of page */}
      <section className="py-16 bg-muted/30">
        <div className="container mx-auto px-4">
          <InternalLinkingOptimizer currentPage="home" />
        </div>
      </section>
    </>
  );
};

export default Home;
